import { ProjectView } from '../../domain/project/projectView/ProjectView';
import { ProjectViewClient } from '../../domain/project/projectView/ProjectViewClient';
import { ProjectViewConstraints } from '../../domain/project/projectView/ProjectViewConstraints';
import { ProjectViewDTO } from '../../domain/project/projectView/ProjectViewDTO';
import { ProjectViewTask } from '../../domain/project/projectView/ProjectViewTask';
import { ProjectViewVehicle } from '../../domain/project/projectView/ProjectViewVehicle';

export class ProjectViewMapper {
  static toDomain(props: ProjectViewDTO): ProjectView {
    const { constraints, vehicle, client, task } = props;
    return ProjectView.create({
      constraints: ProjectViewConstraints.create(constraints),
      vehicle: ProjectViewVehicle.create(vehicle),
      client: ProjectViewClient.create(client),
      task: ProjectViewTask.create(task),
    });
  }

  static toRepository(view: ProjectView): ProjectViewDTO {
    const constraints = view.constraints.getValue();
    const vehicle = view.vehicle.getValue();
    const client = view.client.getValue();
    const task = view.task.getValue();
    return {
      constraints,
      vehicle,
      client,
      task,
    };
  }
}
